import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface GlonassoftCredentials {
  login: string
  password: string
}

interface GlonassoftState {
  credentials: GlonassoftCredentials | null
  server: string | null
  setCredentials: (credentials: GlonassoftCredentials) => void
  setServer: (server: string) => void
  clearCredentials: () => void
  clearServer: () => void
}

export const useGlonassoftStore = create<GlonassoftState>()(
  persist(
    (set) => ({
      credentials: null,
      server: null,

      setCredentials: (credentials: GlonassoftCredentials) => {
        set({ credentials })
      },

      setServer: (server: string) => {
        set({ server })
      },

      clearCredentials: () => {
        set({ credentials: null })
      },

      clearServer: () => {
        set({ server: null })
      },
    }),
    {
      name: 'glonasssoft-storage',
      partialize: (state) => ({
        credentials: state.credentials,
        server: state.server,
      }),
    }
  )
)
